import type { SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useMemo } from "react";
import { useAdminFetchLatestSuretyQuoteUnderwriting } from "./useAdminFetchLatestSuretyQuoteUnderwriting";

export const useFetchAdminBondRequestOutcome = (accountId: SuretyAccountId, id: SuretyQuoteId) => {
	const { latestUnderwriting, latestUnderwritingError } =
		useAdminFetchLatestSuretyQuoteUnderwriting(accountId, id);

	const bondRequest = useMemo(() => {
		if (latestUnderwritingError) {
			return { underwritingStatus: undefined };
		}
		if (latestUnderwriting === undefined) {
			return undefined;
		}
		return { underwritingStatus: latestUnderwriting?.status };
	}, [latestUnderwriting, latestUnderwritingError]);

	return { bondRequest };
};
